import {
  ElementType,
} from 'react';
import TextFieldsIcon from '@mui/icons-material/TextFields';
import SubjectOutlinedIcon from '@mui/icons-material/SubjectOutlined';
import CalendarTodayOutlinedIcon from '@mui/icons-material/CalendarTodayOutlined';
import PersonIcon from '@mui/icons-material/Person';
import EmailOutlinedIcon from '@mui/icons-material/EmailOutlined';
import PhoneOutlinedIcon from '@mui/icons-material/PhoneOutlined';
import HomeOutlinedIcon from '@mui/icons-material/HomeOutlined';
import BadgeOutlinedIcon from '@mui/icons-material/BadgeOutlined';
import ReceiptLongOutlinedIcon from '@mui/icons-material/ReceiptLongOutlined';
import CheckBoxOutlineBlankRoundedIcon from '@mui/icons-material/CheckBoxOutlineBlankRounded';
import NumbersOutlinedIcon from '@mui/icons-material/NumbersOutlined';
import AttachMoneyOutlinedIcon from '@mui/icons-material/AttachMoneyOutlined';
import PercentOutlinedIcon from '@mui/icons-material/PercentOutlined';
import BorderColorRoundedIcon from '@mui/icons-material/BorderColorRounded';
import GestureOutlinedIcon from '@mui/icons-material/GestureOutlined';
import EventAvailableOutlinedIcon from '@mui/icons-material/EventAvailableOutlined';
import RadioGroupIcon from 'core/icons/radioGroup';

export const fieldTypeIconByType: Record<string, ElementType> = {
  shortText: TextFieldsIcon,
  longText: SubjectOutlinedIcon,
  date: CalendarTodayOutlinedIcon,
  fullName: PersonIcon,
  email: EmailOutlinedIcon,
  phone: PhoneOutlinedIcon,
  usAddress: HomeOutlinedIcon,
  ssn: BadgeOutlinedIcon,
  ein: ReceiptLongOutlinedIcon,
  checkbox: CheckBoxOutlineBlankRoundedIcon,
  radioGroup: RadioGroupIcon,
  checkboxGroup: CheckBoxOutlineBlankRoundedIcon,
  number: NumbersOutlinedIcon,
  dollar: AttachMoneyOutlinedIcon,
  integer: NumbersOutlinedIcon,
  percent: PercentOutlinedIcon,
  signature: BorderColorRoundedIcon,
  initial: GestureOutlinedIcon,
  signatureDate: EventAvailableOutlinedIcon,
  signatureTimestamp: EventAvailableOutlinedIcon,
};

export function getFieldTypeIcon(fieldType: string): ElementType {
  return fieldTypeIconByType[fieldType] ?? TextFieldsIcon;
}

export function getCanvasFieldTypeIcon(fieldType: string): ElementType {
  if (fieldType === 'radioGroup' || fieldType === 'checkboxGroup') {
    return fieldTypeIconByType.checkbox;
  }

  return getFieldTypeIcon(fieldType);
}
